import { GET_RESERVATION_DATE_SUCCESS, GET_RESERVATION_DATE_FAILURE, GET_RESERVATION_DATE_CHECK_DATA_FAILURE } from './constants';

export function reducer(state = { payload: [], error: false }, action) {
  switch (action.type) {
    case GET_RESERVATION_DATE_SUCCESS:
      return { payload: [...action.payload], error: false };

    case GET_RESERVATION_DATE_FAILURE:
      return { error: action.payload };

    case GET_RESERVATION_DATE_CHECK_DATA_FAILURE:
      return { payload: [...action.payload.mapData], error: action.payload.error };

    default:
      return state;
  }
}
